/** Registers the open project's owning team for click events (see teamContext.ts). */
import { useEffect } from 'react'
import { useProject } from '../api/hooks'
import { useActiveTeam } from '../contexts/ActiveTeamContext'
import { setProjectTeamContext } from './teamContext'

/** Mount once per open project (WorkspacePageV2). */
export function useProjectTeamAnalytics(projectId: string | undefined): void {
  const project = useProject(projectId ?? '')
  const { teams } = useActiveTeam()
  const ownerTeamId = project.data?.owner_team_id ?? null
  useEffect(() => {
    if (!projectId) return
    setProjectTeamContext(projectId, ownerTeamId ? teams.find((t) => t.id === ownerTeamId) : undefined)
  }, [projectId, ownerTeamId, teams])
}
